export enum StatisticalAnalysisOperation {
    GENERAL_STATISTIC = 'operation.module.statistics-panel.general.access',
    ACTIVITY = 'operation.module.statistics-panel.activity.access',
    DELAY_AND_RESPONSE_TIME = 'operation.module.statistics-panel.delay-and-response-time.access',
    INCIDENT = 'operation.module.statistics-panel.incident.access',
    SAMPLE_TAGS = 'operation.module.statistics-panel.sample-tags.access',
    BILLING = 'operation.module.statistics-panel.billing.access'
}
